var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditPurple(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08301 7.08398H6.49967C6.19026 7.08398 5.89351 7.2069 5.67472 7.42569C5.45592 7.64449 5.33301 7.94123 5.33301 8.25065V13.5007C5.33301 13.8101 5.45592 14.1068 5.67472 14.3256C5.89351 14.5444 6.19026 14.6673 6.49967 14.6673H11.7497C12.0591 14.6673 12.3558 14.5444 12.5746 14.3256C12.7934 14.1068 12.9163 13.8101 12.9163 13.5007V12.9173",
    stroke: "#7953D2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 5.91673L14.0833 7.66673M14.8913 6.84131C15.121 6.61157 15.2501 6.29997 15.2501 5.97506C15.2501 5.65016 15.121 5.33856 14.8913 5.10881C14.6615 4.87907 14.3499 4.75 14.025 4.75C13.7001 4.75 13.3885 4.87907 13.1588 5.10881L8.25 10.0001V11.7501H10L14.8913 6.84131Z",
    stroke: "#7953D2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPurple);
export default __webpack_public_path__ + "static/media/edit_purple.8a7de6a0e327d216fe6dfe8b8a08447c.svg";
export { ForwardRef as ReactComponent };